import { HEROES } from '../../content/site';
import { CellGrid } from './CellGrid';

/**
 * "Meet Your Heros" — the 6-cell neon frame with player photos + name
 * labels, COMING SOON art in unannounced slots, and the traveling diamond
 * chains from the dev frame. Update HEROES in content/site.ts as players
 * are announced. All geometry/layers live in CellGrid.
 */
export function HeroesGrid() {
  return <CellGrid cells={HEROES} showNames diamonds />;
}
